import { useLocation } from 'react-router-dom';

import { safeReturn } from '../../auth/cloudSession.ts';
import { AuthFrame, SignInPanel } from '../../components/cloud/SignIn.tsx';

/** Mojo Up AI Cloud, signed out: shown in place of whatever was asked for, and back there afterwards. */
export function SignInPage() {
  const { pathname, search } = useLocation();
  return (
    <AuthFrame
      title="Sign in to Mojo Up AI Cloud"
      blurb="Your AI workbenches, projects and team, wherever you are."
      footer="New here? Signing in creates your free account: your own workbenches and nodes, their updates, and remote control from here and the phone app."
    >
      <SignInPanel returnTo={safeReturn(`${pathname}${search}`)} />
    </AuthFrame>
  );
}
